export default class ClaimsAbstractServices {
  static getLandingPageReferenceData() {
    logger.error(`Claims:: getLandingPageReferenceData() not implemented`);
  }

  static getClaimsSummary() {
    logger.error(`Claims:: search() not implemented`);
  }

  static getMembersProductsAndModalities() {
    logger.error(`Claims:: getMembersProductsAndModalities() not implemented`);
  }

  static getMultiStepFormReferenceData() {
    logger.error(`Claims:: getMultiStepFormReferenceData() not implemented`);
  }

  static getProvidersForSelectedModality() {
    logger.error(`Claims:: getProvidersForSelectedModality() not implemented`);
  }

  static getServicesForSelectedModality(modalityCode) {
    logger.error(`Claims:: getServicesForSelectedModality(${modalityCode}) not implemented`);
  }

  static submitFile(file) {
    logger.error(`Claims:: submitFiles(${file}) not implemented`);
  }

  static submitClaim(payload) {
    logger.error(`Claims:: submitClaim(${payload}) not implemented`);
  }
}
